import { displayToast } from '../../../helpers/notification';
import { ConfigurationTypes as Type } from '../../types/configuratios';

export function getConfigurationsRequest() {
  return {
    type: Type.GET_CONFIGURATIONS_REQUEST,
  };
}

export function getConfigurationsRequestSuccess(data: any) {
  return {
    type: Type.GET_CONFIGURATIONS_REQUEST_SUCCESS,
    payload: data,
  };
}

export function getConfigurationsRequestFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }
  return {
    type: Type.GET_CONFIGURATIONS_REQUEST_FAILURE,
    error: error,
  };
}
